/* Redux */
import { AnyAction, Dispatch } from 'redux';

/* Interfaces */
import { Payload } from './Payload';
import { StoreType } from './store_types';
import { PurchaseResponse } from './PurchaseResponse';
import { PurchaseStatus } from '../../Shops/shared/__providers__/PurchaseStatusProvider';
import { AnalyticsClient } from '../../../analytics/Client';

export type PaymentError = Error & {
  detail?: string;
};

export interface IPaymentProcessor {
  processPayment(store: StoreType): Promise<PurchaseResponse | void>;
  finishPayment(store: StoreType, ...params: any[]): Promise<any>;
}

export interface WithPayload {
  payload: Payload;
}

export interface WithModalHandler {
  isModalOpen: (opener: boolean) => void;
}

export interface WithAnalyticsClient {
  analyticsClient: AnalyticsClient;
}

export abstract class PaymentProcessor
  implements IPaymentProcessor, WithAnalyticsClient
{
  protected dispatcher: Dispatch<AnyAction>;
  protected loader: (load: boolean) => void;
  readonly analyticsClient: AnalyticsClient;
  protected setPurchaseStatus: (status: PurchaseStatus) => void;

  constructor(
    dispatcher: Dispatch<AnyAction>,
    loader: (load: boolean) => void,
    analyticsClient: AnalyticsClient,
    setPurchaseStatus: (status: PurchaseStatus) => void,
  ) {
    this.dispatcher = dispatcher;
    this.loader = loader;
    this.analyticsClient = analyticsClient;
    this.setPurchaseStatus = setPurchaseStatus;
  }

  abstract processPayment(store: StoreType): Promise<PurchaseResponse | void>;

  abstract finishPayment(store: StoreType, ...params: any[]): Promise<any>;

  abstract handleError(error: PaymentError): void;
}
